<template>
  <v-col :cols="cols">
    <v-card>
      <v-img
        height="160"
        class="white--text align-end"
        :src=" src ? src : 'https://cdn.vuetifyjs.com/images/cards/docks.jpg'"
      >
        <v-card-title>
          <v-icon v-if="cloud" dark>cloud</v-icon>
          {{title}}
        </v-card-title>
        <slot name="title"></slot>
      </v-img>
      <v-card-actions>
        <v-spacer></v-spacer>
        <slot name="actions"></slot>
        <v-tooltip v-if="!cloud" bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>play_arrow</v-icon>
            </v-btn>
          </template>
          <span>启动游戏</span>
        </v-tooltip>
        <v-tooltip v-else bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>cloud_download</v-icon>
            </v-btn>
          </template>
          <span>同步游戏</span>
        </v-tooltip>
        <v-menu
          v-model="value"
          open-on-hover
          close-on-click
          close-on-content-click
          offset-y
          min-width="170"
        >
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>menu</v-icon>
            </v-btn>
          </template>
          <v-list dense>
            <v-subheader>菜单</v-subheader>
            <v-list-item
              v-for="(item, index) in items"
              :key="'_USER-MYGAMEGARD-MENU' + index"
              @click
            >
              <v-list-item-icon style="margin-right: 16px;">
                <v-icon v-text="item.icon"></v-icon>
              </v-list-item-icon>
              <v-list-item-content>{{ item.title }}</v-list-item-content>
            </v-list-item>
          </v-list>
        </v-menu>
      </v-card-actions>
    </v-card>
  </v-col>
</template>

<script>
export default {
  name: "UGC",
  data() {
    return {
      value: false,
      items: [
        { icon: "edit", title: "编辑信息" },
        { icon: "delete", title: "从云端移除" }
      ]
    };
  },
  props: {
    cols: Number,
    title: String,
    src: String,
    cloud: Boolean
  }
};
</script>